import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_TOXIC } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/nekozilla.onsets.json' with { type: 'json' };
import normalImported from './imported/nekozilla-normal.circles.json' with { type: 'json' };
import hardImported from './imported/nekozilla-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/nekozilla-extreme.circles.json' with { type: 'json' };

export const NEKOZILLA_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'nekozilla',
  baseTitle: "Nekozilla",
  description: "Different Heaven's heavy 128 BPM electro. Relentless kicks across the full song.",
  difficulty: 5,
  palette: PALETTE_TOXIC,
  audioSrc: '/audio/circles/nekozilla.mp3',
  attribution: "\"Nekozilla\" by Different Heaven [NCS Release] - https://ncs.io/Nekozilla",
  mapper: "Yukiyo",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 128, offsetMs: 0, totalBeats: 131 },
    hard: { bpm: 128, offsetMs: 0, totalBeats: 131 },
    extreme: { bpm: 128, offsetMs: 0, totalBeats: 131 },
  },
});
